import {Component, Input} from '@angular/core';

@Component({
  selector: 'yo-icon-produitfab',
  templateUrl: './icon-produitfab.component.html',
  styleUrls: ['./icon-produitfab.component.scss'],
  standalone: false
})
export class IconproduitFabriqueComponent {

  @Input() fabrique: boolean;
  @Input() yoDelayMsTooltip : number;

  constructor() {
  }
}
